import { useEffect, useState } from 'react';
import DashboardLayout from './components/DashboardLayout';
import DashboardSummary from './components/DashboardSummary';
import BusinessList from './components/BusinessList';
import { getBusinesses } from '../../services/businessService';

function DashboardPage({ user, token, onLogout, onProfileUpdate, onPasswordChanged }) {
  const [activeView, setActiveView] = useState('Dashboard');
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function refreshBusinesses() {
    setLoading(true);
    setError('');

    try {
      const response = await getBusinesses(token);
      setBusinesses(response.data || []);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let ignore = false;

    async function loadBusinesses() {
      setLoading(true);
      setError('');

      try {
        const response = await getBusinesses(token);

        if (!ignore) {
          setBusinesses(response.data || []);
        }
      } catch (requestError) {
        if (!ignore) {
          setError(requestError.message);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }

    loadBusinesses();

    return () => {
      ignore = true;
    };
  }, [token]);

  return (
    <DashboardLayout
      user={user}
      token={token}
      onLogout={onLogout}
      onProfileUpdate={onProfileUpdate}
      onPasswordChanged={onPasswordChanged}
      activeView={activeView}
      onSelectView={setActiveView}
    >
      {loading ? (
        <div className="mb-4 rounded-2xl border border-[#e6ddd4] bg-white px-4 py-4 text-[#8b7a6d]">
          Loading data...
        </div>
      ) : null}
      {error ? (
        <div className="mb-4 rounded-2xl border border-[#f0d4cb] bg-white px-4 py-4 text-[#b4533f]">
          {error}
        </div>
      ) : null}

      {!loading && !error && activeView === 'Dashboard' ? (
        <>
          <div className="mb-5 flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
            <div>
              <h2 className="m-0 text-3xl font-semibold tracking-[-0.03em] text-[#111111]">
                Dashboard Summary
              </h2>
              <p className="mt-2 text-[#8b7a6d]">
                Overview of all registered businesses across the platform.
              </p>
            </div>
          </div>
          <DashboardSummary businesses={businesses} />
        </>
      ) : null}

      {!loading && !error && activeView === 'Business List' ? (
        <BusinessList
          businesses={businesses}
          token={token}
          user={user}
          onBusinessCreated={refreshBusinesses}
        />
      ) : null}
    </DashboardLayout>
  );
}

export default DashboardPage;
